import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'Tabs',

  props: {
    tabs: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    // TODO: index は現状使用されていないので TabsMixin と併せて修正した方が良いかと
    index: {
      type: Number,
      default: 0,
    },
    tabIndex: {
      type: Number,
      default: 0,
    },
  },

  data(): {
    tabName: string;
  } {
    return {
      tabName: String(this.tabIndex),
    };
  },

  watch: {
    tabName: {
      handler(): void {
        this.$emit('change', this.index, Number(this.tabName));
      },
      immediate: true,
    },
  },
});
